export const ENDPOINT_ADMIN = "https://api.epictower.vn";
export const ENDPOINT_BACKEND = "https://api.epictower.vn/api/v1/";

// export const BASE_URL = "http://backend.lancaster.fservingtech.com/";
export const BASE_URL = "https://api.epictower.vn/api/v1";
